BoardsSidebarSectionView = require 'views/boards-sidebar/boards-sidebar-section-view'
Controller = require 'controller'

module.exports = class BoardsSidebarOrgSectionView extends BoardsSidebarSectionView
  initialize: ->
    super
    # need to listen less
    # something like this: @listenTo @getOrg().boardList, 'add remove reset change:idOrganization', @debouncedRenderBoards
    @listenTo @model.boardList, 'add remove reset change:idOrganization', @debouncedRenderBoards
    @listenTo @getOrg(), 'change:name change:displayName change:logoHash', @render

  getOrg: -> @options.org

  sectionId: -> "org-#{@getOrg().get('id')}"

  sectionName: -> "Team Boards"

  doesTruncate: -> true

  getBoards: ->
    (board for board in @model.boardList.models when (board.getOrganization()?.id == @getOrg().id) && board.isOpen())

  getHeaderInfo: ->
    data = {}
    org = @getOrg()

    if org?
      data = org.toJSON()
      data.isOrg = true
      data.url = Controller.getOrganizationUrl(org.get('name'))
      _hash = org.get('logoHash')
      if _hash
        data.orgLogoUrl = "#{logoDomain}/#{_hash}/30.png"

    data

  postRenderBoardsEvent: ->
    @renderBCStatus()
    return

  renderBCStatus: ->
    @$('.js-has-business-class').toggleClass('hide', !@getOrg().isPremium())
    return

  getTitle: -> @getOrg().get('displayName')



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-org-section-view.coffee